export const MARKER_TYPE = {
  DEFAULT: 'default',
  CONTAINER: 'container',
  INVENTORY_CONTAINER: 'inventoryContainer',
}
